import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=439274ff&scoped=true&"
import script from "./Consents.vue?vue&type=script&lang=js&"
export * from "./Consents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439274ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
installComponents(component, {VCheckbox})
